import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { getFileExtension } from '../../../utils/pathUtils';

const getSupportedFormat = (fileName, supportedFileFormats) => {
  const ext = getFileExtension(fileName);
  if (ext) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < supportedFileFormats.length; i++) {
      const supportedFormat = supportedFileFormats[i];
      if (supportedFormat.formats.includes(ext.toLowerCase())) {
        return supportedFormat;
      }
    }
  }

  return null;
};

export const GET_SUPPORTED_FORMATS_QUERY = gql`
  query supportedFileFormats($consumerId: ID!, $configCode: String!) {
    supportedFileFormats(consumerId: $consumerId, configCode: $configCode) {
      type
      formats
      sizeRange {
        min
        max
      }
    }
  }
`;

export const useFileTypes = configCode => {
  const { data } = useQuery(GET_SUPPORTED_FORMATS_QUERY, {
    variables: {
      consumerId:
        window.AssignmentAppConfig.fileService.FILE_SERVICE_CONSUMER_ID,
      configCode,
    },
  });

  const supportedTypes =
    data && data.supportedFileFormats
      ? data.supportedFileFormats
          .reduce(
            (allFormats, currentType) => allFormats.concat(currentType.formats),
            [],
          )
          .join(',')
      : '';

  const supportedFileFormats = data ? data.supportedFileFormats : [];

  const getSupportedFileFormat = file =>
    getSupportedFormat(file.name, supportedFileFormats);

  const getFileType = file => {
    const supportedFormat = getSupportedFileFormat(file);
    return supportedFormat ? supportedFormat.type : null;
  };

  return {
    supportedTypes,
    supportedFileFormats,
    getSupportedFileFormat,
    getFileType,
  };
};
